import { formatAsArray, isNonEmptyArray } from '../../../../utils'

/**
 * Cascader options carry a JSX `label` for the display and a plain `name` for everything text based
 * (search, sort, rendering of a matched path), hence the fallback below.
 */
export const getOptionText = option =>
  typeof option.name === 'string' ? option.name : typeof option.label === 'string' ? option.label : ''

export const getOptionPathText = path => path.map(getOptionText).join(' / ')

export const searchOptionPath = (inputValue, path) =>
  path.some(option => getOptionText(option).toLowerCase().includes(inputValue.toLowerCase()))

export const sortOptionPaths = (a, b, inputValue) => {
  const search = inputValue.toLowerCase()

  return getOptionPathText(a).toLowerCase().indexOf(search) - getOptionPathText(b).toLowerCase().indexOf(search)
}

/**
 * Cascader roots are the categories, already emitted in their own rank order : only their children
 * have to be sorted, alphabetically.
 */
export const sortOptionsTree = tree => formatAsArray(tree).map(node => isNonEmptyArray(node.children)
  ? { ...node, children: [...node.children].sort((a, b) => getOptionText(a).localeCompare(getOptionText(b))) }
  : node
)
